import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { CustomInputIcon } from "./CustomInput.styles";
import { IconLock, IconEyeShow, IconEyeHide } from "../../assets/icons/Icon";

interface CustomPasswordProps {
  value: string;
  setValue: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  invalid?: boolean;
}

const CustomPassword: React.FC<CustomPasswordProps> = ({
  value,
  setValue,
  onBlur,
  placeholder,
  invalid,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <IconField iconPosition="left">
      <InputIcon>
        <IconLock size={20} />
      </InputIcon>
      <InputText
        className="w-full"
        type={showPassword ? "text" : "password"}
        placeholder={placeholder ?? "Пароль"}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setValue(e.target.value)
        }
        onBlur={onBlur}
        invalid={invalid}
      />
      <CustomInputIcon onClick={() => setShowPassword(!showPassword)}>
        <InputIcon>
          {showPassword ? <IconEyeShow size={20} /> : <IconEyeHide size={20} />}
        </InputIcon>
      </CustomInputIcon>
    </IconField>
  );
};

export default CustomPassword;
